import { ApplyEngagementBlueprintButton } from "PFApp/activities/engagement_blueprint/components/apply_engagement_blueprint_button";
import { ManageRolesButton } from "PFApp/activities/manage_roles/components/manage_roles_button";
import { AddRoleButton } from "PFApp/activities/show/parts/add_role_button";
import { TemplateKey } from "PFApp/constants/templates";
import { Inline } from "PFComponents/containers";
import { Activity } from "PFTypes";

type RolesActionsProps = {
  activity: Activity;
  canBulkManageRoles?: boolean;
  canCreateRoles?: boolean;
  roleKey: TemplateKey.Role | TemplateKey.AuditRole;
};

export const RolesActions = ({
  canBulkManageRoles = false,
  canCreateRoles = true,
  roleKey,
  activity
}: RolesActionsProps) => (
  <Inline>
    {canCreateRoles && (
      <>
        {roleKey === TemplateKey.Role && canBulkManageRoles && (
          <ManageRolesButton engagementId={activity.id} />
        )}
        {roleKey === TemplateKey.Role && <ApplyEngagementBlueprintButton activityId={activity.id} />}
        <AddRoleButton activityId={activity.id} roleKey={roleKey} />
      </>
    )}
  </Inline>
);
